import { useCallback, useEffect, useState } from "react";

export function getPreviewPaneId({ client_document_id, document_name } = {}) {
  return `${client_document_id ?? "doc"}-${document_name ?? "unknown"}`;
}

export function revokePreviewBlob(preview) {
  if (preview?.blobUrl?.startsWith?.("blob:")) {
    URL.revokeObjectURL(preview.blobUrl);
  }
}

export default function useDocumentPreviewPanes() {
  const [previews, setPreviews] = useState([]);

  const addPreview = useCallback((pane) => {
    const id = pane.id || getPreviewPaneId(pane);
    setPreviews((prev) => {
      if (prev.some((p) => p.id === id)) {
        return prev;
      }
      return [
        ...prev,
        {
          ...pane,
          id,
          blobUrl: pane.blobUrl,
          documentType: pane.documentType ?? pane.document_type,
          documentName: pane.documentName ?? pane.document_name,
        },
      ];
    });
  }, []);

  const removePreview = useCallback((id) => {
    setPreviews((prev) => {
      const target = prev.find((p) => p.id === id);
      revokePreviewBlob(target);
      return prev.filter((p) => p.id !== id);
    });
  }, []);

  const closeAllPreviews = useCallback(() => {
    setPreviews((prev) => {
      prev.forEach(revokePreviewBlob);
      return [];
    });
  }, []);

  useEffect(
    () => () => {
      setPreviews((prev) => {
        prev.forEach(revokePreviewBlob);
        return [];
      });
    },
    [],
  );

  return {
    previews,
    addPreview,
    removePreview,
    closeAllPreviews,
    hasPreviews: previews.length > 0,
  };
}
